import { MutationTree } from 'vuex';
import { ProfileState, User } from './types';
import axios from 'axios';

export const mutations: MutationTree<ProfileState> = {
    storeToken(state, token: string) {
        state.error = false;
        state.token = token;
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },
    profileLoaded(state, payload: User) {
        state.error = false;
        state.user = payload;
    },
    profileError(state) {
        state.error = true;
        state.user = undefined;
    },
    clearUserData(state) {
        state.user = undefined;
        location.reload();
    },
};
